<template>
  <div>
    <template v-if="!isTemplate">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center justify-content-between" style="flex-wrap:wrap;width:100%">
          <date-time
            :getParams="formData.date"
            :monthToEnd="false"
            :dateMode.sync="dateMode"
            :dataType="formData.date.data_type"
            supportDatatype
            ref="dataTime"
            showStartMonthTip
            :defaultDateMode="dateMode || 'custom'"
            :defaultTime="defaultTime"
            :disableLocalTimeSet="disableLocalTime"
            :disableLocalTime="disableLocalTime"
            paramTimeFormatter="YYYY-MM-DDTZ"
            @update:dataType="dataTypeChange"
            @update:getParams="dateParamsChange" />
          <div class="d-flex">
            <base-select
              class="ml-2"
              :selectStyle="{width: '100px'}"
              v-model="formData.date.data_type"
              :options="dataTypeOpts"
              @change="dataTypeChangeHandle" />
            <base-select
              class="ml-2"
              :selectStyle="{width: '100px'}"
              v-model="formData.show_bill_type"
              :options="showBillTypeOpts"
              @change="showBillTypeChangeHandle" />
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="d-flex pl-4" style="width: 310px;">
            <div v-if="filterShow">
              {{$t('bill.text_314')}}<span class="primary-color" style="cursor: pointer;" @click="resetFilter">{{$t('bill.text_315')}}</span>
            </div>
            <div class="flex-fill" />
            <div class="primary-color" style="cursor: pointer;" @click="filterToggle">{{filterShow?$t('bill.text_312'):$t('bill.text_313')}}</div>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="isShowOperationService">
        <span class="label-w">{{ $t('bill.operation_num') }}：</span>
        <a-tooltip>
          <template slot="title">{{ $t('bill.operation_service.tooltip') }}</template>
          <a-input-number
            style="width:150px"
            v-model="formData.operation_num"
            :min="OPERATION_NUM_MIN"
            :max="OPERATION_NUM_MAX"
            @change="operationNumChangeHandle" />
        </a-tooltip> {{ $t('bill.operation_num.unit') }}
        <span class="label-w ml-3">{{ $t('bill.service_period') }}：</span>
        <a-tooltip>
          <template slot="title">{{ $t('bill.operation_service.tooltip') }}</template>
          <a-input-number
            style="width:150px"
            v-model="formData.service_period"
            :min="SERVICE_PERIOD_MIN"
            :max="SERVICE_PERIOD_MAX"
            @change="servicePeriodChangeHandle" />
        </a-tooltip> {{ $t('bill.service_period.unit') }}
      </div>
      <analysises-group :formData="formData" />
    </template>
    <div :style="{paddingRight: `${isTemplate?0:filterShow?350:0}px`, position: 'relative'}" :class="`mt-3`">
      <analysises-chart ref="analysisesChart" :formData="formData" :dataList="dataList" :dataGroup="dataGroup" :loading="chartLoading" :originDataList="chartDataList" :billType="billType" @exportExcel="exportExcel" />
      <analysises-table ref="analysisesTable" :formData="formData" :dataList="dataList" :dataGroup="dataGroup" :originDataList="originDataList" :isShowSubtotal="isShowSubtotal" :billType="billType" :isGoPage="isGoPage" @showChange="(val) => isShowSubtotal = val" @goBillPage="goBillPage" />
      <template v-if="!isTemplate">
        <div v-show="filterShow" class="pl-4" style="width: 350px;position:absolute;right:0;top:0">
          <analysises-filter ref="analysisesFilter" :formData="formData" :billType="billType" @billTypeChange="billTypeChange" />
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import * as R from 'ramda'
import { mapState } from 'vuex'
// import { uuid, completionDate } from '@/utils/utils'
import { ANALYSIS_GROUP_RATE_LIST, ANALYSIS_SPLITS_MAP } from '@Bill/constants'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { uuid } from '@/utils/utils'
import WindowsMixin from '@/mixins/windows'
import AnalysisesFilter from './AnalysisesFilter'
import AnalysisesTable from './AnalysisesTable'
import AnalysisesChart from './AnalysisesChart'
import AnalysisesGroup from './AnalysisesGroup'
import AnalysisesMixin from '../mixins/analysises'

export default {
  name: 'BillAnalysisIndex',
  components: {
    AnalysisesFilter,
    AnalysisesTable,
    AnalysisesChart,
    AnalysisesGroup,
  },
  mixins: [WindowsMixin, currencyRequest, AnalysisesMixin],
  props: {
    isTemplate: Boolean,
    billShared: Boolean,
    projectShared: Boolean,
    isShowOperationService: Boolean,
    isGoPage: {
      type: Boolean,
      default: true,
    },
    reportLoaded: Boolean,
  },
  data () {
    // const { tag_key } = this.$route.query
    const { start_date, end_date, date_mode, bill_type } = this.getInitDate()
    return {
      loading: false,
      chartLoading: false,
      filterShow: true,
      dateMode: date_mode,
      seriesArr: {
        trend: [],
        usage: [],
        top10: [],
      },
      // 拉取后的原数据
      originDataList: [],
      // 经过排序/处理字段后的数据
      dataList: [],
      chartDataList: [],
      defaultTime: {
        start: start_date ? this.$moment(start_date) : this.$moment().subtract(6, 'month').startOf('month'),
        end: end_date ? this.$moment(end_date) : this.$moment(new Date()).endOf('month').subtract('month', 1).endOf('month'),
      },
      disableLocalTime: !!start_date || !!date_mode,
      form: this.$form.createForm(this),
      formItemLayout: {
        wrapperCol: { span: 16 },
        labelCol: { span: 5 },
      },
      tagsGroup: [null, null],
      tagOpts: [],
      instanceTagOpts: [],
      projectTagOpts: [],
      tagGroupParams: {},
      projectTagGroupParams: {},
      instanceTagGroupParams: {},
      tagLoading: false,
      instanceTagLoading: false,
      projectTagLoading: false,
      billType: bill_type,
      currentDataParams: {},
      dataGroup: [],
      isShowSubtotal: true,
      dataTypeOpts: [
        { id: 'day', name: this.$t('bill.show_group_day') },
        { id: 'month', name: this.$t('bill.show_group_month') },
        { id: 'dimension', name: this.$t('bill.show_group_dimension') },
      ],
      showBillTypeOpts: [
        { id: 'only_show_bill', name: this.$t('meter.only_show_bill') },
        { id: 'show_bill_usage', name: this.$t('meter.show_bill_usage') },
      ],
    }
  },
  computed: {
    ...mapState('bill', {
      showZeroBills: state => state.showZeroBills,
    }),
    groupOpts () {
      const targets = ANALYSIS_GROUP_RATE_LIST.filter(item => {
        if (this.$store.getters.isProjectMode) {
          return item.key !== 'domain'
        }
        const fieldMap = {
          cloudprovider_name: 'cloudprovider',
          owner_name: 'owner',
          linked_name: 'linked',
        }
        const field = fieldMap[item.key] || item.key
        if (!this.$isScopedPolicyMenuHidden(`fee_hidden_items.${field}`)) {
          return item
        }
      })
      const rets = targets.map(item => {
        if (item.t) {
          item.value = this.$t(item.t)
        }
        return item
      })
      return rets
    },
    billTypes () {
      return this.billType
    },
    splitMessage () {
      return this.formData.tag_val_split ? ANALYSIS_SPLITS_MAP[this.formData.tag_val_split].label : this.$t('bill.split')
    },
    dataGroupLen () {
      return this.dataGroup.length
    },
    currentChartParams () {
      const { group = [] } = this.currentDataParams
      return {
        ...this.currentDataParams,
        group: [group[0], group[1]],
      }
    },
  },
  watch: {
    formData: {
      deep: true,
      handler (val) {
        this.$nextTick(() => {
          this.fetchData()
        })
      },
    },
    billShared: {
      handler () {
        this.fetchData()
      },
    },
    projectShared () {
      this.fetchData()
    },
    billType (val) {
      this.dataList = this.getSortDataBySum(this.originDataList, val)
    },
    showZeroBills () {
      this.fetchData()
    },
    currentChartParams: {
      deep: true,
      handler: function (val, oldVal) {
        if (!_.isEqual(val, oldVal)) {
          this.updateChartDataList()
        }
      },
    },
  },
  created () {
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    if (this.isTemplate) {
      this.fetchData()
    }
  },
  methods: {
    updateChartDataList () {
      this.chartDataList = this.originDataList
    },
    getInitDate () {
      // 从费用总览携带参数
      const { start_date: start_date1, end_date: end_date1 } = this.$route.query
      // 从报表携带参数
      const { formData = { date: {} } } = this.$route.params
      const { bill_type = 'stat_value' } = formData || {}
      const { start_date: start_date2, end_date: end_date2, date_mode = '', data_type = '' } = formData.date || {}
      return {
        start_date: (start_date1 || start_date2 || '').replace('TZ', ''),
        end_date: (end_date1 || end_date2 || '').replace('TZ', ''),
        date_mode,
        data_type,
        bill_type: [bill_type],
      }
    },
    genReportData () {
      const date = {
        ...this.formData.date,
        date_mode: this.dateMode,
      }
      if (date.date_mode !== 'custom') {
        delete date.start_date
        delete date.end_date
      }
      const values = this.form.getFieldsValue(['tag_key', 'tag_key1', 'project_tag_key', 'project_tag_key1'])
      return {
        ...this.formData,
        date,
        ...values,
        bill_type: this.billType,
      }
    },
    setFormTemplateData (initData) {
      const keys = Object.keys(initData)
      keys.map(key => {
        if (this.formData.hasOwnProperty(key) && R.type(initData[key]) === R.type(this.formData[key]) && key !== 'cloudprovider') { // 废弃原来保存的cloudprovider参数，防止影响cloudprovider_id过滤
          if (key === 'date') {
            const date = {
              ...initData[key],
            }
            if (date.date_mode && date.date_mode !== 'custom') {
              let start = this.$moment()
              let end = this.$moment()
              if (date.date_mode === 'month') {
                start = this.$moment().startOf('month')
                end = this.$moment().endOf('month')
              } else if (date.date_mode === 'last_month') {
                start = this.$moment().subtract(1, 'month').startOf('month')
                end = this.$moment().subtract(1, 'month').endOf('month')
              } else if (date.date_mode === 'month_before_last_month') {
                start = this.$moment().subtract(2, 'month').startOf('month')
                end = this.$moment().subtract(2, 'month').endOf('month')
              } else if (date.date_mode === 'last_6_month') {
                start = this.$moment().subtract(6, 'month').startOf('month')
                end = this.$moment().subtract(1, 'month').endOf('month')
              } else if (date.date_mode === 'last_12_month') {
                start = this.$moment().subtract(12, 'month').startOf('month')
                end = this.$moment().subtract(1, 'month').endOf('month')
              } else if (date.date_mode === 'year') {
                start = this.$moment().startOf('year')
                end = this.$moment().endOf('year')
              }
              date.start_date = start.format('YYYY-MM-DD') + 'TZ'
              date.end_date = end.format('YYYY-MM-DD') + 'TZ'
            }
            if (!_.isEqual(this.formData[key], date)) {
              this.formData[key] = date
            }
          } else {
            if (!_.isEqual(this.formData[key], initData[key])) {
              this.formData[key] = initData[key]
            }
          }
        } else if (key === 'bill_type') {
          const billType = R.is(Array, initData[key]) ? initData[key] : [initData[key]]
          this.billType = this.$store.state.common.bill.globalConfig.cost_conversion_available ? billType : ['stat_value']
        } else if (key === 'cloudprovider_id') {
          this.formData.cloudprovider = initData.cloudprovider_id
          this.$refs.analysisesFilter && this.$refs.analysisesFilter.fetchDistinct('cloudprovider_name')
        } else if (key === 'group') {
          this.formData.groups = initData.group.map((g, index) => {
            if (['tag', 'instance_tag', 'project_tag'].includes(g)) {
              const valuekey = `${g}_key${index === 0 ? '' : '1'}`
              const value = { [g]: initData[valuekey] }
              return {
                group: g,
                tag: undefined,
                instance_tag: undefined,
                project_tag: undefined,
                ...value,
              }
            } else {
              return {
                group: g,
                tag: undefined,
                instance_tag: undefined,
                project_tag: undefined,
              }
            }
          })
        }
      })
      const currentKeys = Object.keys(this.formData)
      currentKeys.map(key => {
        if (key.endsWith('_condition')) {
          if (initData.hasOwnProperty(key)) {
            this.formData[key] = initData[key]
          } else {
            this.formData[key] = 'equals'
          }
        }
      })
      if (initData.groups.some(item => item.group === 'aggregate_usage_unit')) {
        this.formData.show_bill_type = 'show_bill_usage'
      } else {
        this.formData.show_bill_type = 'only_show_bill'
      }
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          if (!err) {
            resolve(values)
          } else {
            reject(err)
          }
        })
      })
    },
    dataTypeChangeHandle (val) {
      this.formData.date.data_type = val
    },
    dataTypeChange (val) {
      if (this.formData.date.data_type === 'dimension' && this.groupCount > 1) {
        return
      }
      this.formData.date.data_type = val
    },
    dateParamsChange (params) {
      if (this.formData.date.data_type === 'dimension' && this.groupCount > 1) {
        this.formData.date = { ...params, data_type: this.formData.date.data_type }
        return
      }
      this.formData.date = { ...params }
    },
    async fetchData () {
      if (!this.isTemplate && !this.reportLoaded) return
      this.$nextTick(() => {
        const params2 = this.genParams()
        delete params2.spec
        delete params2.financial_unit
        delete params2.usage_type
        this.transParams(params2)
        delete params2.$t
        // 判断是否有真实的参数更新了
        if (_.isEqual(this.currentDataParams, params2)) return
        this.loading = true
        // 判断是否chart需要loading
        const { group = [] } = params2
        const p = {
          ...params2,
          group: [group[0], group[1]],
        }
        if (!_.isEqual(p, this.currentChartParams)) {
          this.chartLoading = true
        }
        Promise.all([this._getData()]).then(() => {
          this.loading = false
          this.chartLoading = false
        })
      })
    },
    genFormDataParams () {
      const params = {}
      R.forEachObjIndexed((value, key) => {
        if (key !== 'date') {
          if (R.is(Array, value)) {
            params[key] = value
          } else if (value) {
            params[key] = value
          }
        }
      }, this.formData)
      delete params.tag
      delete params.project_tag
      delete params.instance_tag
      delete params.instance_tag_key
      delete params.group
      delete params.groups
      delete params.show_bill_type
      // 标签聚合时，不出现在group参数中
      // params.group = R.clone(params.group).filter(key => key !== 'tag')
      // 标签分隔
      if (params.tag_val_split) {
        params.tag_val_split = ANALYSIS_SPLITS_MAP[params.tag_val_split].value
      }
      // 云订阅改为id过滤
      if (params.hasOwnProperty('cloudprovider')) {
        params.cloudprovider_id = params.cloudprovider
        params.cloudprovider_id_condition = params.cloudprovider_condition
        delete params.cloudprovider
        delete params.cloudprovider_condition
      }
      if (!this.showZeroBills) {
        params.skip_zero_bills = true
      }
      return params
    },
    genParams () {
      // eslint-disable-next-line camelcase
      const queryType = this.formData.show_bill_type === 'show_bill_usage' ? 'expense_usage_trend' : 'expense_trend'
      const { groups, date } = this.formData
      const { start_date, end_date, data_type } = date
      const formDataParams = this.genFormDataParams()
      const tagParams = {}
      const instanceTagParams = {}
      const projectTagParams = {}
      let metadataIndex = 0
      let metadataIndex1 = 0
      let metadataIndex2 = 0
      for (const key in this.formData.tag) {
        if (key === 'without_bill_tags') {
          tagParams.without_bill_tags = true
        } else if (key === 'with_bill_tags') {
          tagParams.with_bill_tags = true
        } else {
          tagParams[`tags.${metadataIndex}.key`] = key
          if (this.formData.tag[key]) {
            tagParams[`tags.${metadataIndex}.value`] = this.formData.tag[key]
          }
          metadataIndex++
        }
      }
      for (const key in this.formData.instance_tag) {
        if (key === 'without_instance_tags') {
          instanceTagParams.without_instance_tags = true
        } else if (key === 'with_instance_tags') {
          instanceTagParams.with_instance_tags = true
        } else {
          if (R.is(Array, this.formData.instance_tag[key]) && this.formData.instance_tag[key].length) {
            this.formData.instance_tag[key].map(value => {
              instanceTagParams[`instancetags.${metadataIndex2}.key`] = key
              instanceTagParams[`instancetags.${metadataIndex2}.value`] = value
              metadataIndex2++
            })
          } else {
            instanceTagParams[`instancetags.${metadataIndex2}.key`] = key
            metadataIndex2++
          }
        }
      }
      for (const key in this.formData.project_tag) {
        if (key === 'without_project_tags') {
          projectTagParams.without_project_tags = true
        } else if (key === 'with_project_tags') {
          projectTagParams.with_project_tags = true
        } else {
          if (R.is(Array, this.formData.project_tag[key]) && this.formData.project_tag[key].length) {
            this.formData.project_tag[key].map(value => {
              projectTagParams[`project_tags.0.${metadataIndex1}.key`] = key
              projectTagParams[`project_tags.0.${metadataIndex1}.value`] = value
              metadataIndex1++
            })
          } else {
            projectTagParams[`project_tags.0.${metadataIndex1}.key`] = key
            metadataIndex1++
          }
        }
      }
      const tagFixList = ['bill', 'project', 'instance']
      tagFixList.map(key => {
        if (tagParams[`without_${key}_tags`] && tagParams[`with_${key}_tags`]) {
          delete tagParams[`without_${key}_tags`]
          delete tagParams[`with_${key}_tags`]
        }
        if (projectTagParams[`without_${key}_tags`] && projectTagParams[`with_${key}_tags`]) {
          delete projectTagParams[`without_${key}_tags`]
          delete projectTagParams[`with_${key}_tags`]
        }
        if (instanceTagParams[`without_${key}_tags`] && instanceTagParams[`with_${key}_tags`]) {
          delete instanceTagParams[`without_${key}_tags`]
          delete instanceTagParams[`with_${key}_tags`]
        }
      })
      // 按标签聚合 参数
      let groupParams = []
      for (let i = 0; i < groups.length; i++) {
        if (['tag', 'instance_tag', 'project_tag'].includes(groups[i].group)) {
          if (groups[i][groups[i].group]) {
            groupParams[i] = `${groups[i].group}:${groups[i][[groups[i].group]]}`
          }
        } else if (groups[i].group === 'owner_name') {
          groupParams[i] = 'account'
        } else {
          groupParams[i] = groups[i].group
        }
      }
      groupParams = groupParams.filter(item => item)
      const $t = uuid()
      const params = {
        $t,
        query_type: queryType,
        start_date,
        end_date,
        data_type: data_type === 'dimension' ? 'month' : data_type,
        scope: this.$store.getters.scope,
        admin: this.$store.getters.isAdminMode,
        group: groupParams,
        ...formDataParams,
        ...tagParams,
        ...instanceTagParams,
        ...projectTagParams,
        ...R.clone(this.currencyParams),
      }
      if (this.billShared) {
        params.is_prepaid_amortizing = true
      } else {
        params.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        params.is_project_sharing = true
      } else {
        params.is_project_sharing = false
      }
      if (!params.filter) {
        params.filter = []
      }
      params.filter = Array.from(new Set(params.filter))
      // 产品过滤
      if (params.spec && params.spec.length) {
        const specs = params.spec.map(key => `'${key}'`)
        params.filter.push(`spec.in(${specs.join(',')})`)
      }
      if (params.financial_unit && params.financial_unit.length) {
        const financial_units = params.financial_unit.map(key => `'${key}'`)
        params.filter.push(`financial_unit.in(${financial_units.join(',')})`)
      }
      if (params.usage_type && params.usage_type.length) {
        const usage_types = params.usage_type.map(key => `'${key}'`)
        params.filter.push(`usage_type.in(${usage_types.join(',')})`)
      }
      return params
    },
    transParams (params) {
      if (params.domain && params.domain.length) {
        params.domain.map((d, idx) => {
          params[`project_domain_ids.${idx}`] = d
        })
        delete params.domain
      }
      if (params.project && params.project.length) {
        params.project.map((p, idx) => {
          params[`project_ids.${idx}`] = p
        })
        delete params.project
      }
      const keys = Object.keys(params)
      keys.map(key => {
        if (key.endsWith('_condition') && !key.startsWith('spec') && !key.startsWith('financial_unit') && !key.startsWith('usage_type')) {
          if (params[key] === 'not_equals') {
            const origin_key = key.replace('_condition', '')
            params[origin_key + '_negation'] = true
          }
          delete params[key]
        }
        if (key === 'filter') {
          params[key] = params[key].map(str => {
            if (str.startsWith('spec') && params.spec_condition === 'not_equals') {
              return str.replace('.in(', '.notin(')
            }
            if (str.startsWith('financial_unit') && params.financial_unit_condition === 'not_equals') {
              return str.replace('.in(', '.notin(')
            }
            if (str.startsWith('usage_type') && params.usage_type_condition === 'not_equals') {
              return str.replace('.in(', '.notin(')
            }
            return str
          })
        }
      })
      delete params.spec_condition
      delete params.financial_unit_condition
      delete params.usage_type_condition
    },
    addDiscountValue (originData) {
      if (originData.length) {
        originData.map(level1Item => {
          if (level1Item.data) {
            level1Item.data.map(level2Item => {
              if (level2Item.data) {
                level2Item.data.map(level3Item => {
                  level3Item.discount_value = (level3Item.gross_value || 0) - (level3Item.stat_value || 0)
                })
              } else {
                level2Item.discount_value = (level2Item.gross_value || 0) - (level2Item.stat_value || 0)
              }
            })
          }
        })
      }
    },
    addIdEnd (originData) {
      const data = R.clone(originData)
      const { group } = this.formData
      if (originData.length) {
        originData.map((level1Item, index1) => {
          if (level1Item.data) {
            if (group.length === 1 || (group.length === 2 && group[0].includes('cloudprovider'))) {
              const { name, id } = level1Item
              const len = data.filter(item => item.name === name).length
              if (len > 1) {
                level1Item.name = `${name}${id ? ` (${id.substring(0, 6)})` : ''}`
              }
            } else if (group.length === 2 && group[1].includes('cloudprovider')) {
              level1Item.data.map(level2Item => {
                const { name, id } = level2Item
                const len = data[index1].data.filter(item => item.name === name).length
                if (len > 1) {
                  level2Item.name = `${name}${id ? ` (${id.substring(0, 6)})` : ''}`
                }
              })
            }
          }
        })
      }
    },
    _getData () {
      const params = this.genParams()
      delete params.spec
      delete params.financial_unit
      delete params.usage_type
      this.transParams(params)
      if (!params.start_date) return Promise.resolve()
      return this.analysisM.list({
        params,
      }).then(({ data: { data } }) => {
        // 补充优惠金额
        this.addDiscountValue(data)
        // 补充重复名称的id后缀
        this.addIdEnd(data)
        // this.originDataList = data
        const params2 = this.genParams()
        delete params2.spec
        delete params2.financial_unit
        delete params2.usage_type
        this.transParams(params2)
        delete params2.$t
        const isEqual = _.isEqual(params, params2)
        if (isEqual) {
          this.dataList = this.getSortDataBySum(data, this.billType)
          this.dataGroup = params2.group
          this.originDataList = data
          this.currentDataParams = params2
        }
      }).catch(error => {
        throw error
      })
    },
    filterToggle () {
      this.filterShow = !this.filterShow
      this.$nextTick(() => {
        this.$refs.analysisesChart.$refs.analysisChart.$refs.chart.echarts.resize()
      })
    },
    resetFilter () {
      const formData = {
        groups: this.formData.groups,
        platform_brand: [],
        account: [],
        linked_name: [],
        cloudprovider: [],
        region: [],
        origin_region: [],
        project: [],
        domain: [],
        charge_type: undefined,
        resource_type: [],
        origin_res_type: [],
        external_project_name: [],
        usage_type: [],
        product_type: [],
        origin_usage_type: [],
        origin_record_type: [],
        spec: [],
        financial_unit: [],
        date: this.formData.date,
        tag: {},
        tag_key: this.formData.tag_key,
        tag_key1: this.formData.tag_key1,
        project_tag: {},
        project_tag_key: this.formData.project_tag_key,
        project_tag_key1: this.formData.project_tag_key1,
        instance_tag: {},
        instance_tag_key: this.formData.instance_tag_key,
        instance_tag_key1: this.formData.instance_tag_key1,
      }
      const keys = Object.keys(this.formData)
      keys.map(key => {
        if (key.endsWith('_condition')) {
          formData[key] = 'equals'
        }
      })
      this.formData = formData
      this.billType = ['stat_value']
    },
    goBillPage (params) {
      const originParams = this.genParams()
      // 已选参数
      const { platform_brand, account_id, cloudprovider, region_ext_id, domain, project } = originParams
      // 备选参数
      const { options: filterOptions = {} } = this.$refs.analysisesFilter
      const { accounts = [], cloudprovider_name = [], regions = [], domains = [], projects = [] } = filterOptions
      // 平台
      if (platform_brand && platform_brand.length) {
        originParams.brand = platform_brand
        delete originParams.platform_brand
        originParams.brand_condition = originParams.platform_brand_condition
        delete originParams.platform_brand_condition
      }
      const getFilterName = function (list, targetId, idKey = 'item_id', nameKey = 'item_name') {
        const targetList = list.filter(item => item[idKey] === targetId)
        if (!targetList[0]) {
          return null
        }
        const id = targetList[0][idKey] || ''
        const idFirst = id.substr(0, 8)
        let name = targetList[0][nameKey] || ''
        if (name.indexOf(idFirst) > -1) {
          name = name.replace(` (${idFirst})`, '') // 兼容重名后用id区分的资源名 xxx（55sdf48a）
        }
        return name
      }

      const genParam = function (originList, originKey, targetKey, filteredList, idKey, nameKey) {
        if (originList && originList.length) {
          const list = []
          originList.map(id => {
            const name = getFilterName(filteredList, id, idKey, nameKey)
            if (name) {
              if (targetKey === 'account' && id === 'yunion') {
                list.push('OneStack')
              } else {
                list.push(name)
              }
            }
          })
          if (list.length) originParams[targetKey] = list
        }
        if (originKey !== targetKey) delete originParams[originKey]
      }
      genParam(account_id, 'account_id', 'account', accounts)
      genParam(cloudprovider, 'cloudprovider_id', 'cloudprovider_id', cloudprovider_name, 'id', 'name')
      genParam(region_ext_id, 'region_ext_id', 'region', regions)
      genParam(domain, 'domain', 'domain', domains)
      genParam(project, 'project', 'project', projects)
      const transParams = {}
      const transKeys = ['brand', 'project', 'account', 'region', 'origin_region', 'cloudprovider_id', 'domain', 'owner_name', 'linked_name', 'resource_type', 'financial_unit', 'spec', 'origin_res_type', 'external_project_name', 'usage_type', 'product_type', 'origin_usage_type', 'origin_record_type']
      transKeys.map(key => {
        if (params[key]) {
          transParams[key] = [params[key]]
        }
      })
      originParams.tag = this.formData.tag || {}
      originParams.instance_tag = this.formData.instance_tag || {}
      originParams.project_tag = this.formData.project_tag || {}
      // 去除同时选中某项和排序某项的冲突
      for (const key in params) {
        if (params[key] && originParams[`${key}_condition`] === 'not_equals') {
          delete originParams[`${key}_condition`]
        }
      }
      // 合并filter和table中选择的标签
      const tagAll = this.mergeTag(originParams, params)
      this.$router.push({ name: this.formData.date?.data_type === 'day' ? 'BillDetail' : 'BillMonthlyDetail', params: { ...originParams, ...params, ...transParams, tag: tagAll } })
    },
    mergeTag (param1, param2) {
      const { tag: tag1 = {} } = param1
      const { tag: tag2 = {} } = param2
      const allTag = R.clone(tag1)
      for (const key in tag2) {
        allTag[key] = allTag[key] && !(tag2[key] in allTag[key]) ? allTag[key].concat(tag2[key]) : tag2[key]
      }
      return allTag
    },
    exportExcel () {
      this.$refs.analysisesTable.download()
    },
    showSplitConfig () {
      this.createDialog('BillAnalysisSetSplitDialog', {
        split: this.formData.tag_val_split,
        splitChange: this.splitChange,
      })
    },
    splitChange (split) {
      if (this.formData.tag_val_split !== split) {
        this.formData.tag_val_split = split
      }
    },
    billTypeChange (type) {
      const next = Array.isArray(type) ? type.filter(Boolean) : (type ? [type] : [])
      if (!next.length) return
      this.billType = next
    },
    showBillTypeChangeHandle (val) {
      if (val === 'show_bill_usage') {
        this.formData.groups = [this.formData.groups[0], { group: 'aggregate_usage_unit' }]
      } else {
        this.formData.groups = this.formData.groups.filter(item => item.group !== 'aggregate_usage_unit')
      }
    },
  },
}
</script>
<style lang="less">
.analysis-tag-dropdown {
  max-width: 400px;
}
.analysis-tag > .ant-form-item-label > .ant-form-item-required {
  color: #000000a6;
}
.label-w {
  display: inline-block;
  width: 86px;
}
</style>
